import * as React from 'react'
import { NameValueListItem } from '../../NameValueList/NameValueListItem/NameValueListItem'
import { InfoTooltip } from '@sales-center/components'
import { DraftLeadTypeTooltipContents } from '@user/components/DraftLeads/DraftLeadTypeTooltip/DraftLeadTypeTooltipContents'
import Stack from '@mui/material/Stack'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'
import { Theme } from '@mui/material/styles'

type Props = {
  dateSubmitted?: string | Date
  submittedBy?: string
  type: string
}

export function SubmissionInfo(props: Props) {
  const { dateSubmitted, submittedBy, type } = props
  const { formatDate } = useLocalizationDateFormat()
  const date =
    typeof dateSubmitted === 'string' ? new Date(dateSubmitted) : dateSubmitted

  const TypeValue = (
    <Stack direction="row" alignItems="center" gap={0.4}>
      {type}{' '}
      <InfoTooltip
        tooltipPlacement="left-start"
        infoText={<DraftLeadTypeTooltipContents />}
      />
    </Stack>
  )

  return (
    <Stack
      direction="column"
      rowGap={2}
      sx={{ marginBottom: (theme: Theme) => theme.spacing(1.2) }}
    >
      <NameValueListItem
        label="Date Submitted"
        value={date ? formatDate(date, 'date') : '-'}
      />
      <NameValueListItem label="Submitted By" value={submittedBy ?? '-'} />
      <NameValueListItem label="Type" value={TypeValue} />
    </Stack>
  )
}
